/* eslint-disable */

const ptBr = {
    'play-store': 'Baixar na Play Store',
    'app-store': 'Baixar na App Store',
}

export default ptBr